import { Component, Input, AfterViewInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import { ActionCoCardModel, QueovalDateTime, ActionCoHistoryType, Invoice, Corporation, ActionCoTypeDevis, PipeCard, QueovalDate, Person } from '../../models';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { I18n, CustomDatepickerI18n } from '../../bodisplay/dynamictag/dynamictag-addon/datepicker/datepicker.service';
import { ToastService } from '../../toast';
import { ActionCoService } from './action-co-services/action-co.service';
import { ActionCoHistoService } from './action-co-services/action-co-histo.service';
import { Parser } from '@angular/compiler/src/ml_parser/parser';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-card',
  templateUrl: './action-co-card.component.html',
  styleUrls: ['./action-co-card.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }, ActionCoService, ActionCoHistoService] // define custom NgbDatepickerI18n provide
})

export class ActionCoCardComponent implements AfterViewInit {

  constructor(
    public indParam: CoreService,
    protected http: HttpService,
    protected domSanitizer: DomSanitizer,
    protected qDateService: QueovalDateService,
    protected changeDetector: ChangeDetectorRef,
    protected toast: ToastService,
    public actionCoService: ActionCoService,
    public actionCoHistoService: ActionCoHistoService,
  ) { }




  //public model: ActionCoCardModel = new ActionCoCardModel();
  public dataListCollabo: Array<string> = [];
  public dataListContact: Array<string> = [];

  public awaitNameCollabo: boolean = true;
  public awaitNameContact: boolean = true;
  public awaitNameCustomers: boolean = true;

  public idActionCo: string = '';
  public ActionCoHistoryType = ActionCoHistoryType;

  public NameCollaboConnected: string = '';
  public LogoCollaboConnected: string = '';

  public Customer: Corporation = new Corporation();

  public strDesctiption: string = '';
  public dataLoaded: boolean = false;
  public actionCoTypeDevis = ActionCoTypeDevis;

  public openView: number;

  public __type: string = '';

  @Input('OpenView') set SetOpenView(value: string) {
    for (let i: number = 0; i < this.tabs.length; i++) {
      const tab = this.tabs[i];
      if (value && ActionCoOnglet[tab.Type].toLowerCase() === value.toLowerCase()) {
        this.openView = tab.Type;
        break;
      }
    };
  }

  @Input('idActionCo') set SetIdActionCo(value: string) {
    this.idActionCo = value;
  }

  @Input('Type_EVE') set SetType(value: string) {
    this.actionCoService.Model.Type = value;
    this.__type = value;
  }

  @Input('TypeDevis') set SetTypeDevis(value: string) {
    if ((<any>Object).values(ActionCoTypeDevis).includes(value)) {
      this.actionCoService.Model.TypeDevis = value;
      this.VisibilityOnglet();
    } else {
      this.actionCoService.Model.TypeDevis = ActionCoTypeDevis.Produit;
    }

  }

  @Input('LockedCustomer') set SetCustomer(value: Corporation) {
    if (value && value.Id != '' && value.Id != '0') {
      this.actionCoService.Model.Customer = value;
      this.Customer = value;
    }
  }
  @Input('Contacts') set SetDataListContacts(value: Array<Person>) {
    if (value && value.length > 0) {
      this.actionCoService.Model.Contacts = value;
      this.dataListContact = value.map(c => c.Value);
    }
  }


  @Input('Date') set SetDate(value: QueovalDateTime) {
    if (value)
      this.actionCoService.Model.Date = value;
  }
  @Input('IdDonnee') set SetIdCollabo(value: string) {
    if (value)
      this.actionCoService.Model.IdCollabo = value;
  }
  public modalContainer: boolean = false;
  @Input('modalContainer') set SetModelContainer(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.modalContainer = true;
    } else {
      this.modalContainer = value;
    }
  }

  @Output() actionCoCreated: EventEmitter<{ Card: PipeCard, Type: string }> = new EventEmitter<{ Card: PipeCard, Type: string }>();


  public tabs: Array<{ Type: ActionCoOnglet, Font: string, Name: string, Active: boolean, WasOpenedForTheFirstTime: boolean, Visible: boolean, Locked: boolean }> = [
    { Active: true, WasOpenedForTheFirstTime: true, Visible: false, Locked: false, Name: 'Action', Type: ActionCoOnglet.Action, Font: 'fas fa-balance-scale mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'Devis', Type: ActionCoOnglet.Devis, Font: 'fas fa-file-invoice mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'Calculateur', Type: ActionCoOnglet.Calculateur, Font: 'fas fa-file-calculator mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'LDM', Type: ActionCoOnglet.LDM, Font: 'fas fa-file-invoice mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'E-sign', Type: ActionCoOnglet.Esign, Font: 'fas fa-signature mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'E-mail', Type: ActionCoOnglet.Email, Font: 'fas fa-paper-plane mr-2', },
    { Active: false, WasOpenedForTheFirstTime: false, Visible: false, Locked: true, Name: 'Transformation', Type: ActionCoOnglet.Transformation, Font: 'fas fa-file-export mr-2', }
  ];



  //#region LIFE CYCLE 
  public ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.actionCoService.DevisCreated$.subscribe((idDevis: string) => {
      this.actionCoService.Model.Invoice.Ident = idDevis;
      this.UnlockOnglet('DevisCreated$');
    });

    this.actionCoService.DevisSigned$.subscribe((isSigned: boolean) => {
      this.actionCoService.Model.Invoice.DevisSigne = isSigned;
      this.UnlockOnglet('DevisSigned$');
    });

    this.actionCoService.CorpIsClient$.subscribe((isClient: boolean) => {
      this.actionCoService.Model.Customer.IsClient = isClient;
      this.UnlockOnglet('CorpIsClient$');
    });

    this.actionCoService.ActionCoCreated$.subscribe((idActionCo: string) => {
      this.actionCoService.Model.idActionCo = idActionCo;
      this.UnlockOnglet('ActionCoCreated$');
    });


    this.Init();
  }
  //#endregion

  //#region PUBLIC FUNCTIONS
  public ActiveTab(indexType: number): void {
    this.tabs.forEach(tab => {
      if (tab.Type === indexType && tab.Visible && !tab.Locked) {
        tab.Active = true;
        tab.WasOpenedForTheFirstTime = true;
      }
      else tab.Active = false;
    });
    if (this.tabs.findIndex(t => t.Active) === -1) this.tabs[0].Active = true;
  }
  //#endregion
  //#region  PRIVATE FUNCTIONS

  private Init(emitCard: boolean = false): void {
    this.changeDetector.detectChanges();
    this.actionCoService.Model.idActionCo = this.idActionCo ? this.idActionCo : "0";
    this.UnlockOnglet('INIT');
    const collab: Promise<void | ActionCoCardModel> = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_COLLABO_BY_ID_ACTION_CO/${this.actionCoService.Model.idActionCo}|${this.actionCoService.Model.IdCollabo}/`).toPromise();
    collab.then(
      (data: ActionCoCardModel) => {
        this.actionCoService.Model.IdCollabo = data.IdCollabo;
        this.actionCoService.Model.NameCollabo = data.NameCollabo;
        this.actionCoService.Model.Collaborateurs = data.Collaborateurs;
        this.actionCoService.Model.LogoCollabo = data.LogoCollabo;

        this.dataListCollabo = data.Collaborateurs.map(c => c.Value);
        this.awaitNameCollabo = false;
        this.changeDetector.detectChanges();
      });
    this.NameCollaboConnected = `${this.indParam.AppParams.LoggedUser.NomfaPER} ${this.indParam.AppParams.LoggedUser.Pre01PER}`;
    const logo: Promise<void | ActionCoCardModel> = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_LOGO_COLLABO/${this.indParam.AppParams.LoggedUser.Ident}/`).toPromise();
    logo.then(
      (data: ActionCoCardModel) => {
        this.LogoCollaboConnected = data.LogoCollabo;
        this.changeDetector.detectChanges();
      });
    let contact: Promise<void | ActionCoCardModel> | null = null;
    let data: Promise<void | ActionCoCardModel> | null = null;
    let devis: Promise<void | ActionCoCardModel> | null = null;
    let history: Promise<void | ActionCoCardModel> | null = null;

    this.actionCoService.Model.Sujet = this.actionCoService.Model.getLabelTypeDevis();

    if (this.actionCoService.Model.idActionCo && this.actionCoService.Model.idActionCo != '0') {

      contact = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_CONTACT_DATAS_BY_ID_ACTION/${this.actionCoService.Model.idActionCo}/`).toPromise();
      contact.then(
        (data: ActionCoCardModel) => {
          this.actionCoService.Model.Customer = data.Customer;
          this.actionCoService.OnCorpIsClient(data.Customer.IsClient);
          this.Customer = data.Customer;

          this.actionCoService.Model.ContactPrincipal = JSON.parse(JSON.stringify(data.ContactPrincipal));
          this.actionCoService.Model.Contacts = data.Contacts;
          if (data.Contacts && data.Contacts.length > 0)
            this.dataListContact = data.Contacts.map(c => c.Value);

          this.awaitNameContact = false;
          this.awaitNameCustomers = false;
          this.changeDetector.detectChanges();
        });

      data = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_ACTION_CO_DATAS/${this.actionCoService.Model.idActionCo}/`).toPromise();
      data.then(
        (data: ActionCoCardModel) => {
          this.actionCoService.Model.Sujet = data.Sujet;
          this.actionCoService.Model.Description = data.Description;
          this.strDesctiption = this.actionCoService.Model.Description;
          this.actionCoService.Model.InfoProjet = data.InfoProjet;
          this.actionCoService.Model.Amount = data.Amount;
          this.actionCoService.Model.Ponderation = data.Ponderation;
          this.actionCoService.Model.PricePonderation = data.PricePonderation;

          this.actionCoService.Model.Date = data.Date;
          this.actionCoService.Model.Type = data.Type;
          this.actionCoService.Model.TypeDevis = data.TypeDevis;

          this.actionCoService.Model.Status = data.Status;
          this.actionCoService.Model.Remark = data.Remark;
          this.actionCoService.Model.Reason = data.Reason;
          this.actionCoService.Model.lockThumb = data.lockThumb;

          this.actionCoService.Model.Priorite = data.Priorite;
          this.actionCoService.Model.IsCloture = data.IsCloture;

          this.VisibilityOnglet();
        });

      devis = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_DEVIS_BY_ID_ACTION_CO/${this.actionCoService.Model.idActionCo}/`).toPromise();
      devis.then(
        (data: ActionCoCardModel) => {
          this.actionCoService.Model.Invoice = data.Invoice;
          if (this.actionCoService.Model.Invoice.Ident) {
            this.UnlockOnglet('GET_DEVIS_BY_ID_ACTION_CO');
          }
          this.changeDetector.detectChanges();
        });

      history = this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_HISTORY_BY_ID_ACTION_CO/${this.actionCoService.Model.idActionCo}/`).toPromise();
      history.then(
        (data: ActionCoCardModel) => {
          this.actionCoService.Model.History = data.History;
          this.changeDetector.detectChanges();
        });
    }
    Promise.all([data, devis]).then(() => {
      if (!emitCard && this.openView) {
        this.ActiveTab(this.openView);
      }
    });
    Promise.all([collab, logo, contact, data, devis, history]).then(() => {
      this.dataLoaded = true;
      if (emitCard) {
        const card: PipeCard = new PipeCard();
        card.Ident = this.actionCoService.Model.idActionCo;
        card.Client = this.actionCoService.Model.Customer.SocialReason;
        card.Title = this.actionCoService.Model.Sujet;
        card.Info = this.actionCoService.Model.Description;
        card.Date = this.actionCoService.Model.Date;
        card.Price = parseFloat(this.actionCoService.Model.Amount);
        card.Ponderation = this.actionCoService.Model.Ponderation;
        card.PricePonderation = this.actionCoService.Model.PricePonderation;
        card.Document = 0;
        card.ContactId = this.actionCoService.Model.ContactPrincipal.Id;
        card.ClientId = this.actionCoService.Model.Customer.Id;
        card.CollaboName = this.actionCoService.Model.NameCollabo;
        card.CollaboId = this.actionCoService.Model.IdCollabo;
        card.CollaboAvatarUrl = this.actionCoService.Model.LogoCollabo;
        card.Contact = this.actionCoService.Model.ContactPrincipal.Value;
        card.HistoNb = this.actionCoService.Model && this.actionCoService.Model.History ? this.actionCoService.Model.History.length : 0;
        card.Priorite = this.actionCoService.Model.Priorite;

        const qNow: QueovalDate = this.qDateService.Now();
        if (this.qDateService.Compare(this.actionCoService.Model.Date, '<', qNow)) card.DateBadgeColor = 'R';
        else if (this.qDateService.Compare(this.actionCoService.Model.Date, '=', qNow)) card.DateBadgeColor = 'O';
        else card.DateBadgeColor = 'G';

        const date: Date = new Date(Number.parseInt(this.actionCoService.Model.Date.annee), Number.parseInt(this.actionCoService.Model.Date.mois) - 1, Number.parseInt(this.actionCoService.Model.Date.jour));
        const options: any = { month: 'short' };
        card.DateAbbreviation = `${this.actionCoService.Model.Date.jour} ${new Intl.DateTimeFormat(this.indParam.AppParams.culture, options).format(date)}`;

        if (history != null && this.actionCoService.Model.History.length > 0) {
          card.HistoLastUpdate = this.actionCoService.Model.History[0].Date;
          let dtNow = this.qDateService.ToDate(qNow);
          let lastDt = this.qDateService.ToDate(card.HistoLastUpdate);
          if (dtNow != null && lastDt != null) {
            card.HistoNumberOfDays = Math.round((dtNow.getTime() - lastDt.getTime()) / (1000 * 60 * 60 * 24));
          }
          card.HistoLastInfo = `Nombre d'historique: ${card.HistoNb}\nDernier historique au ${this.qDateService.ToString(card.HistoLastUpdate, 'dd/MM/yyyy')}: ${this.actionCoService.Model.History[0].Label} `;
        }


        card.StatusBadgeColor = this.actionCoService.Model.Status.toLowerCase() === 'gagne' ? 'G' : this.actionCoService.Model.Status.toLowerCase() === 'perdu' ? 'R' : '';
        card.Status = this.actionCoService.Model.Status;
        card.IsCloture = this.actionCoService.Model.IsCloture;
        //card.Filtered =
        this.actionCoCreated.emit({ Card: card, Type: this.actionCoService.Model.Type });
      }
      this.changeDetector.detectChanges();
    });
    this.changeDetector.detectChanges();
  }



  public GetHistory(): void {
    this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_HISTORY_BY_ID_ACTION_CO/${this.actionCoService.Model.idActionCo}/`).subscribe(
      (data: ActionCoCardModel) => {
        this.actionCoService.Model.History = data.History;
      });
  }
  public ActionCoCreated(value: string): void {
    this.idActionCo = value;
    this.dataLoaded = false;
    this.actionCoService.Model.History = [];
    this.Init(true);
  }



  private UnlockOnglet(origine: string) {
    this.tabs.forEach(tab => {
      switch (tab.Type) {
        case ActionCoOnglet.Esign:
          tab.Locked = !this.actionCoService.Model.Invoice.DevisSigne && this.actionCoService.Model.Invoice.Ident ? false : true;
          break;
        case ActionCoOnglet.Transformation:
          tab.Locked = this.actionCoService.Model.Customer.IsClient && this.actionCoService.Model.Invoice.DevisSigne && this.actionCoService.Model.Invoice.Ident ? false : true;          
          break;
        case ActionCoOnglet.Devis:
        case ActionCoOnglet.Calculateur:
        case ActionCoOnglet.LDM:
        case ActionCoOnglet.Email:
          tab.Locked = this.actionCoService.Model.idActionCo != "0" ? false : true;
          break;
      }
    });
  }
  private VisibilityOnglet() {
    this.tabs.forEach(tab => {
      switch (tab.Type) {
        case ActionCoOnglet.Transformation:
        case ActionCoOnglet.Devis:
          tab.Visible = ([ActionCoTypeDevis.Devis, ActionCoTypeDevis.Produit] as string[]).includes(this.actionCoService.Model.TypeDevis);
          break;
        case ActionCoOnglet.LDM:
        case ActionCoOnglet.Calculateur:
          tab.Visible = ([ActionCoTypeDevis.lettreDeMission, ActionCoTypeDevis.CAC] as string[]).includes(this.actionCoService.Model.TypeDevis);
          break;
        case ActionCoOnglet.Esign:
        case ActionCoOnglet.Email:
        case ActionCoOnglet.Action:
          tab.Visible = true;
          break;
      }
    });
  }
  //#endregion


}




export enum ActionCoOnglet {
  Action,
  Devis,
  Calculateur,
  LDM,
  Esign,
  Email,
  Transformation,
}
